import cn from 'classnames'
import {FC} from 'react'

import {ArrowIcon} from '@/components/common/icons/ArrowIcon'
import {HOVER_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextFontWeight} from '../common/content/Text'

type ArrowButtonProps = {
  variant?: 'left' | 'right'
  onClick?: () => void
  text?: string
  disabled?: boolean
}

export const ArrowButton: FC<React.PropsWithChildren<ArrowButtonProps>> = ({
  variant = 'right',
  onClick,
  text,
  disabled = false,
}) => {
  return (
    <>
      <button
        className={cn('arrow-button', variant)}
        onClick={onClick}
        disabled={disabled}
        type="button"
      >
        {text && (
          <div className="text">
            <Text fontWeight={TextFontWeight.bold} align={variant === 'left' ? 'left' : 'right'}>
              {text}
            </Text>
          </div>
        )}
        <div className="arrow">
          <ArrowIcon color={theme.palette.text.default} />
        </div>
      </button>

      <style jsx>{`
        .arrow-button {
          display: flex;
          align-items: center;
        }
        .arrow-button:disabled {
          opacity: 0.4;
          pointer-events: none;
        }
        .arrow {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          flex: 0 0 56px;
          background-color: ${theme.palette.background.default};
          border-radius: 50%;
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[300]};
          transition: background-color ${HOVER_TRANSITION}ms ease-in-out;
        }
        .arrow:hover,
        .arrow:focus {
          background-color: ${theme.palette.background.butter};
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.butter[100]};
        }
        .left {
          flex-direction: row-reverse;
        }
        .left .arrow {
          transform: rotate(180deg);
        }
        .text {
          margin-right: ${theme.spacing[3]};
        }
        .left .text {
          margin-left: ${theme.spacing[3]};
          margin-right: 0;
        }
        @media ${MOBILE_SCREENSIZE} {
          .arrow {
            width: 40px;
            height: 40px;
            flex: 0 0 40px;
          }
        }
      `}</style>
    </>
  )
}
